import API from "../../../store/api";
import { getAllGroups } from "./getAllGroups";
import { clearGroups } from "../../../store/actions/groupsActions";
import { setNotifications } from '../../../store/actions/notificationActions';
import { clearMessage, setMessage } from '../../../store/actions/dialogActions';
import { authLogout } from '../../../store/actions/authActions';

export const createGroup = (groupData, bearerAuth, formFunction) => {
  return async dispatch => {

    dispatch(setMessage({ type: 'LOAD' }))

    API.post(`/api/portal/groups`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .send(groupData)
      .ok(res => res.status === 201 || res.status === 401)
      .then((response) => {
        if (response.status === 201) {
          dispatch(clearMessage)
          dispatch(getAllGroups(bearerAuth))
          dispatch(setNotifications({
            type: 'success',
            message: 'Successfully created.'
          }))
          formFunction()
        } else if (response.status === 401) {
          dispatch(clearGroups);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          }
        }
        dispatch(setMessage({
          title: 'Create Group Failed',
          message: message,
          type: 'ERR',
        }))
      })
  }
}
/* Sample groupData
 * {
 *   "name": "EMS",
 *   "enabled": "true",
 *   "siteId": "07ff846d-40ed-4075-be1d-f0e7ecf5ee1p",
 * }
*/